import React from 'react';
import './style.scss';

interface BannerDexSwapProps {
    children?: React.ReactNode;
}

const BannerDexSwap: React.FC<BannerDexSwapProps> = () => {
    return (
        <div className="banner dex-swap">
            <img src="./images/home/products/2.png" alt="" />
        </div>
    );
};

export default BannerDexSwap; 